import React from "react";
import { FormattedMessage } from "react-intl";
import CheckboxFormInput from "components/framework/forms/CheckboxFormInput";
import { ListGroup } from "reactstrap";
import { SettingsNotificationDto } from "services/apis/types/settings/SettingsNotificationDto";
import { DefaultNotifications } from "services/apis/types/settings/DefaultNotifications";


type Props = {
    tollFreeNotificationType: boolean;
    handleCheckAllTollFree: (value: boolean) => void;
    filteredTollFreeNotification: SettingsNotificationDto[];
    handleChangeTollFreeNotifications: (value: SettingsNotificationDto, index: number) => void;
};

export default function ActivitiesSettings(props: Props) {
    return (
        <div>
            <ListGroup as="ul" className="background-color-ul">
                <div className="col-lg-12 border-settings">
                    <CheckboxFormInput
                        className="col-lg-6 checkbox-settings pt-2"
                        label={DefaultNotifications.NotificationType}
                        value={"tollFreeNotificationType"}
                        checked={props.tollFreeNotificationType}
                        handleInputChange={(value: boolean) =>
                            props.handleCheckAllTollFree(value)
                        }
                    />
                </div>
                {(props.filteredTollFreeNotification.length > 0) ? (props.filteredTollFreeNotification.map((tollfreeSettings, index) => (
                    <div className="col-lg-12 mt-2">
                        <CheckboxFormInput
                            className="col-lg-6 checkbox-settings-sub"
                            label={tollfreeSettings.activityKindName}
                            value={(tollfreeSettings.activityKindId).toString()}
                            checked={tollfreeSettings.modifiedAssigned}
                            handleInputChange={(value: boolean) =>
                                props.handleChangeTollFreeNotifications({ ...tollfreeSettings, modifiedAssigned: value }, index)
                            }
                        >
                            <div className="sub-card-message">
                                {tollfreeSettings.description}
                            </div></CheckboxFormInput>
                    </div>
                ))) : (<>
                    <div className="py-4 text-center">
                        <FormattedMessage id="table.noData" />
                    </div>
                </>)
                }
            </ListGroup>
        </div>
    );
}

